import React from 'react';

const STATUS_CONFIG = {
    EN_LOCATION: { label: 'En location', color: '#2980b9', bg: '#eaf3fb' },
    SALE:        { label: '⚠ Sale',      color: '#c0392b', bg: '#fdf3f2' },
    DISPONIBLE:  { label: 'Disponible',  color: '#27ae60', bg: '#eafaf1' },
};

const getEffectiveStatus = (bed) => {
    if (bed.status === 'SALE') return 'SALE';
    if (bed.status === 'EN_LOCATION' || bed.isRent) return 'EN_LOCATION';
    return 'DISPONIBLE';
};

const DetailBedForm = ({ bed }) => {
    const effectiveStatus = getEffectiveStatus(bed);
    const cfg = STATUS_CONFIG[effectiveStatus];

    const infoRows = [
        { label: 'Modèle',      value: bed.model },
        { label: 'Moteurs',     value: bed.motors },
        { label: 'Année',       value: bed.year },
        { label: 'N° de série', value: bed.serialNumber },
    ];

    return (
        <div style={{ padding: '28px 20px 20px' }}>

            {/* En-tête */}
            <div style={{ marginBottom: 16 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                    <span style={{ fontSize: 22, fontWeight: 'bold' }}>Lit #{bed.number}</span>
                    <span style={{
                        padding: '3px 10px',
                        borderRadius: 12,
                        backgroundColor: cfg.bg,
                        color: cfg.color,
                        border: `1px solid ${cfg.color}`,
                        fontSize: 12,
                        fontWeight: 'bold',
                    }}>
                        {cfg.label}
                    </span>
                </div>
                {bed.client && (
                    <div style={{ color: '#555', fontSize: 14 }}>
                        <strong>{bed.client}</strong>
                        {bed.pharmacy ? ` · ${bed.pharmacy}` : ''}
                        {bed.address && (
                            <div style={{ fontSize: 12, marginTop: 4 }}>
                                <a
                                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(bed.address)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#2980b9', textDecoration: 'none' }}
                                >
                                    📍 {bed.address}
                                </a>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <hr style={{ margin: '0 0 4px' }} />

            {/* Infos */}
            {infoRows.map(({ label, value }) => value ? (
                <div key={label} style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '12px 0',
                    borderBottom: '1px solid #f0f0f0',
                }}>
                    <span style={{ color: '#888', fontSize: 13 }}>{label}</span>
                    <span style={{ fontWeight: '500', fontSize: 14 }}>{value}</span>
                </div>
            ) : null)}

            {/* CTA */}
            <a
                href={`/bed/${bed.number}`}
                className="btn btn-primary w-100"
                style={{ borderRadius: 8, marginTop: 20, display: 'block', textAlign: 'center' }}
            >
                Voir le détail / historique du lit →
            </a>
        </div>
    );
};

export { DetailBedForm };
